__webpack_require__.p = "https://cxx.cardsvault.net/blindboxs/";